export default {
  'depositSlip.title': 'Deposit Info',
  'depositSlip.hide': 'Hide Deposit Slip',
  'depositSlip.show': 'Show Deposit Slip',
  'image.notAvailable': 'Image is unavailable. Please try again later.'
};
